import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAccidentsInTreatment,
  getDeviationsByTypeCount,
  getEmptyExpiredAccidentsCount,
  getPendingAuthorizations,
  setActualidadDashboardProvider,
} from "../../../actions/dashboard";
import { StyledDashboard } from "../../styled/dashboard";
import DashboardContainer from "./dashboardContainer";

const Container = () => {
  const dispatch = useDispatch();

  const selectedProvider = useSelector(
    (state) => state.providers.selectedProvider,
  );
  const actualidadProviderId = useSelector(
    (state) => state.dashboard.actualidadProviderId,
  );
  const accidentsInTreatment = useSelector(
    (state) => state.dashboard.accidentsInTreatment,
  );
  const pendingAuthorizations = useSelector(
    (state) => state.dashboard.pendingAuthorizations,
  );
  const emptyExpiredAccidentsCount = useSelector(
    (state) => state.dashboard.emptyExpiredAccidentsCount,
  );
  const deviationsByTypeCount = useSelector(
    (state) => state.dashboard.deviationsByTypeCount,
  );

  useEffect(() => {
    if (!selectedProvider) return;
    if (actualidadProviderId === selectedProvider) return;

    const isLoading =
      accidentsInTreatment.isFetching ||
      pendingAuthorizations.isFetching ||
      emptyExpiredAccidentsCount.isFetching ||
      deviationsByTypeCount.isFetching;
    if (isLoading) return;

    dispatch(setActualidadDashboardProvider(selectedProvider));
    dispatch(getAccidentsInTreatment());
    dispatch(getPendingAuthorizations());
    dispatch(getEmptyExpiredAccidentsCount());
    dispatch(getDeviationsByTypeCount());
  }, [dispatch, selectedProvider, actualidadProviderId]);

  return (
    <StyledDashboard.DashboardContainerStyled>
      <DashboardContainer />
    </StyledDashboard.DashboardContainerStyled>
  );
};

export default Container;
